/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ZocdocTimeslot } from "./ZocdocTimeslot";

export interface ZocdocAvailabilityResult {
  provider_location_id: string;
  timeslots: ZocdocTimeslot[];
}
